module.exports = __webpack_public_path__ + "static/media/apresentacoes_voxar.a85d7495.mp4";